module.exports = "<main>\n\t<router-outlet></router-outlet>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/Desktop/Hotel-Data/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main